import { render, staticRenderFns } from "./ExpirationIcon.vue?vue&type=template&id=054c42c0&"
import script from "./ExpirationIcon.vue?vue&type=script&lang=js&"
export * from "./ExpirationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTooltip,
})
